import React from 'react';
import { init } from '@fitbit/ttag';

const I18nContext = React.createContext(init());

export default I18nContext;
